import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizeShipmentSpotBidAddress } from './normalize';

export const fetchShipmentSpotBidAddress = createProvider(api.fetchShipmentSpotBidAddress)
  .andThen((res) => normalizeShipmentSpotBidAddress(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch list aborted');
    } else {
      console.error('Fetch list was failed:', error);
    }
    throw error;
  });
